module.exports = __webpack_public_path__ + "img/full_thumb_sample_3.0ad2a835.png";